const childRoutes = (prop) => [{
        path: 'dashboard',
        name: prop + '.dashboard',
        meta: { auth: true },
        component: () => import('../pages/dashboard/List.vue')
    },
    {
        path: 'manual-information',
        name: prop + '.manual-information',
        meta: { auth: true },
        component: () => import('../pages/manual-information/List.vue')
    },
    {
        path: 'manage-service-point',
        name: prop + '.manage_service_point',
        meta: { auth: true },
        component: () => import('../pages/manage-service-point/List.vue')
    },
    {
        path: 'service-eligibility',
        name: prop + '.service_eligibility',
        meta: { auth: true },
        component: () => import('../pages/service-eligibility/List.vue')
    },
    {
        path: 'manual-faq',
        name: prop + '.manual-faq',
        meta: { auth: true },
        component: () => import('../pages/manual-faq/List.vue')
    },
    {
        path: 'committee-management',
        name: prop + '.committee-management',
        meta: { auth: true },
        component: () => import('../pages/committee-management/List.vue')
    },
    {
        path: 'complain',
        name: prop + '.complain',
        meta: { auth: true },
        component: () => import('../pages/complain/List.vue')
    }
]
const routes = [{
    path: '/social-welfare-service/manual-content-management',
    name: 'social_welfare_service.manual_content_management',
    component: () => import('@/layouts/SocialWelfareServiceLayout.vue'),
    meta: { auth: true },
    children: childRoutes('social_welfare_service.manual-content-management')
}]
export default routes
